<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="chapter-number---IVP" id="_idParaDest-5" title="Dedication"><a id="_idTextAnchor052"></a><a id="_idTextAnchor053"></a><span class="pagebreak" id="page5" title="5"></span></h2>
<p class="firstcenter">This book is dedicated to my brothers from other mothers, the men whom I call my lifelong friends and who continue to inspire me to be a better man:</p>
<p class="firstcenter"><i>Mike Aquilina, Joe Dilillo, Joe Groshek, Paul Jarzembowski, George Kalantzis, Graziano Marcheschi, Glenn Murray and Rich Vetrano.<br/>
<br/>
<br/></i></p>
<p class="firstcenter"><i>As iron sharpens iron, so man sharpens his fellow man.</i></p>
<p class="firstcenter">Proverbs 27:17</p>
<p class="firstleft"><a id="_idTextAnchor054"></a><a id="_idTextAnchor055"></a><a id="_idTextAnchor056"></a><a id="_idTextAnchor057"></a><a id="_idTextAnchor058"></a><a id="_idTextAnchor059"></a><a id="_idTextAnchor060"></a><a id="_idTextAnchor061"></a><a id="_idTextAnchor062"></a><a id="_idTextAnchor063"></a><span class="pagebreak" id="page6" title="6"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6fcc180b